import(/* webpackMode: "eager" */ "/codebuild/output/src2678048505/src/app/home/page.tsx");
